//
// Copyright ArangoDB GmbH, Cologne, Germany
// All rights reserved. See LICENSE.md in the project root for license information.
//

import React from "react";
import { Header, Icon, Message } from "semantic-ui-react";

const GCPPrivateNetworkConfirmationInfoView = () => {
  return (
    <>
      <Header data-testid="gcpPrivateNetworkConfirmationInfoHeader">Please confirm that you want to use a Private Endpoint for your deployment.</Header>
      <Message icon>
        <Icon name="info" size="small" />
        <Message.Content data-testid="gcpPrivateNetworkConfirmationInfoMessage">
          Note that once a deployment has a Private Endpoint connection, it cannot be converted back to a public endpoint, without help from the Arango Managed
          Platform Insights Platform support team.
        </Message.Content>
      </Message>
    </>
  );
};

export default GCPPrivateNetworkConfirmationInfoView;
